import { render, staticRenderFns } from "./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=template&id=3bf026df&"
import script from "./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=script&lang=js&"
export * from "./RelatedDeliverablesSocialMediaSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports